<template>
    <div class="component" @click="addCustomer(data)">
      <div :class="{'vx-card p-2 bg-unknown' : data.faceType == 'unknown', 'vx-card p-2 bg-success' : data.faceType == 'employee' || data.faceType == 'loyalty-customer'}">
          <div class="vx-row" >
              <div class="vx-col md:w-5/12 w-full text-center">
                  <div class="component w-full">
                      <img class="round" width="80" height="80" :src="data.imageUrl ? data.imageUrl : imageDefault" alt="">
                  </div>
                  <div class="component w-full">
                      <small class="text-white">{{ data.customerType }}</small>
                  </div>
              </div>
              <div class="vx-col md:w-7/12 w-full pl-2 m-auto">
                  <div class="w-full">
                      <span class="font-bold text-white" style="font-size:18px">{{ data.fullName ? data.fullName : 'Không xác định'}}</span>
                      <br />
                      <small class="text-white">{{ data.organizationBranchName }}</small>
                      <br v-if="data.organizationBranchName" />
                      <small class="text-white">{{ data.checkinTime }}</small>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>

  <script>
  export default {
      props: {
          data: {}
      },
      data(){
          return {
              imageDefault: require('@/assets/images/card/businessman.jpeg')
          }
      },

      methods: {
          addCustomer(e) {
              if (e.faceType === 'unknown') {
                  this.$router.push(`/user/add-customer?imageUrl=${e.imageUrl}`);
              }
          },

      }
  }
  </script>

  <style>
  .bg-unknown {
      background-color: #eb5455d1;
  }
  </style>
